import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { ScrollView, View } from 'native-base';

import { ConsortiumDetails } from './components/ConsortiumDetails';
import { CustomerDetails } from './components/CustomerDetails';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { RecommendationDetails } from './components/RecommendationDetails';
import { SuccessMessage } from './components/SuccessMessage';

export const Sent = () => {
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View minW="container">
        <VStack
          py={Spacing['inset.lg']}
          space={Spacing['inline.xxs']}
          px={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'], lg: 0 }}>
          <Header />
          <Shadow level={1} borderRadius={BoxRadius.sm}>
            <VStack space={Spacing['inline.xxs']} p={Spacing['inline.xxs']}>
              <SuccessMessage />
              <CustomerDetails />
              <ConsortiumDetails />
              <RecommendationDetails />
            </VStack>
          </Shadow>
          <Footer />
        </VStack>
      </View>
    </ScrollView>
  );
};
